import React from 'react';
import Header from '../components/Header';
import MainGrid from '../components/MainGrid';

export default function Analytics({selectedDate}) {
  return (
    <>
      <MainGrid selectedDate={selectedDate} />
    </>
  );
}
